// Whose Pinned / Recent lists these are.
//
// The side menu's Pinned Matters and Recent Matters / Clients / Contacts
// (lib/pinnedMatters.js, lib/recentItems.js) and Global Search's recent
// searches (lextrack_recent_searches) live in this browser's localStorage,
// shared by everyone who signs in on it.  So that the next person on a shared
// computer never sees the previous person's matter, client and contact titles
// (some may be walled from them: full menu, ☰ drawer, rail ⭐ popover,
// Ctrl+K), the lists belong to one user: QUICK_LISTS_OWNER_KEY holds that
// user's id, and claimQuickListsFor(uid) empties the lists before someone
// else's session starts.  The same person signing out and back in keeps them
// (pins are sticky).  Lists written before the owner was recorded go to the
// first person to sign in (verifier follow-up, 2026-10-20).
//
// AuthContext calls it with the signed-in user's id BEFORE setting the user,
// on every path that sets one (page load with a stored token, and every
// sign-in), so nothing renders the old titles even once.

import { clearPinnedMatters } from './pinnedMatters'
import { recentMattersTracker, recentClientsTracker, recentContactsTracker } from './recentItems'

export const QUICK_LISTS_OWNER_KEY = 'lextrack_quick_lists_owner'
// GlobalSearch's history of typed searches.
const RECENT_SEARCHES_KEY = 'lextrack_recent_searches'

// Returns true when it emptied someone else's lists.
export function claimQuickListsFor (uid) {
  if (uid === null || uid === undefined || uid === '') return false
  const id = String(uid)
  let owner
  try { owner = window.localStorage.getItem(QUICK_LISTS_OWNER_KEY) } catch { return false } // storage blocked: nothing kept
  if (owner === id) return false
  const someoneElse = owner !== null
  if (someoneElse) {
    clearPinnedMatters()
    recentMattersTracker.clear()
    recentClientsTracker.clear()
    recentContactsTracker.clear()
    try { window.localStorage.removeItem(RECENT_SEARCHES_KEY) } catch { /* blocked */ }
  }
  try { window.localStorage.setItem(QUICK_LISTS_OWNER_KEY, id) } catch { /* full / blocked */ }
  return someoneElse
}
